'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import React, { useEffect, useState } from 'react';

type GeoLocationErrorDialogProps = {
  geoLocationError?: GeolocationPositionError;
};

export const GeoLocationErrorDialog = ({ geoLocationError }: GeoLocationErrorDialogProps): React.JSX.Element => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!!geoLocationError);
  }, [geoLocationError]);

  let textToShow = '';

  if (geoLocationError?.code === geoLocationError?.PERMISSION_DENIED) {
    textToShow = 'Allow Cinemark to get your location by enabling location services in your browser settings.';
  } else {
    textToShow = 'We were unable to search and find the theater closest to you by your location.';
  }

  return (
    <Dialog open={open}
      onOpenChange={setOpen}
    >
      <DialogContent className="dialog-md min-w-[175px] max-w-11/12">
        <DialogHeader>
          <DialogTitle data-test="geo-location-error-title">
            Your Browser Location May Be Disabled
          </DialogTitle>
          <DialogDescription className="hide" />
        </DialogHeader>

        <p data-test="geo-location-error-message">{textToShow}</p>
      </DialogContent>
    </Dialog>
  );
};
